import { render, staticRenderFns } from "./addAndEditRole.vue?vue&type=template&id=22b60dc3&scoped=true"
import script from "./addAndEditRole.vue?vue&type=script&lang=js"
export * from "./addAndEditRole.vue?vue&type=script&lang=js"
import style0 from "./addAndEditRole.vue?vue&type=style&index=0&id=22b60dc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b60dc3",
  null
  
)

export default component.exports